import { GitBranch } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useActiveScenario } from "@/hooks/world";
import { useStore } from "@/model/store";

/** A slim amber bar under the header on every page while a scenario is active. */
export function ScenarioBanner() {
	const { scenario } = useActiveScenario();
	const setActive = useStore((s) => s.setActiveScenario);
	const { pathname } = useLocation();
	if (!scenario) return null;
	const onPage = pathname === `/scenario/${scenario.id}`;
	return (
		<div className="border-t border-scenario/30 bg-scenario/12 text-sm" role="status">
			<div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-1.5 lg:px-8">
				<GitBranch className="size-3.5 shrink-0 text-scenario" aria-hidden />
				<span className="min-w-0 truncate">
					Viewing: <strong className="font-semibold">{scenario.name}</strong>
				</span>
				<span className="ml-auto flex shrink-0 items-center gap-3 whitespace-nowrap">
					{!onPage && (
						<Link to={`/scenario/${scenario.id}`} className="font-medium underline-offset-2 hover:underline">
							Open<span className="hidden sm:inline"> scenario</span>
						</Link>
					)}
					<button className="font-medium underline-offset-2 hover:underline" onClick={() => setActive(null)}>
						Back to Baseline
					</button>
				</span>
			</div>
		</div>
	);
}
